// extracted by mini-css-extract-plugin
export default {"sidebar":"Side_sidebar__B+2+P","routes":"Side_routes__jfdsP","activePath":"Side_activePath__9OadK"};